export { default } from "./withTheme.js";
export * from "./withTheme.js";